<template>
  <div class="pb-50 pt-50 authenticate" style="margin: auto; max-width: 1346px">
    <el-row>
      <el-col class="text-left" :xs="24" :sm="24" :md="12">
        <h2 class="pb-20 login-form-heading">
          <span class="compte mb-13">
            {{ $t("users.login.account") }}
          </span>
        </h2>
      </el-col>
    </el-row>
    <el-row>
      <el-col
        class="text-left bg-accent-light mr-30 login-form"
        :xs="24"
        :sm="24"
        :md="12"
      >
        <el-col class="bg-accent-light" :xs="24" :sm="24" :md="18">
          <div class="rectangle bg-accent-light text-left p-20">
            <div class="text-left mb-5">
              <span class="connexion">{{ $t("users.login.title") }}</span>
            </div>
            <AuthenticateComponent
              :cta-submit-text="$t('users.login.label.login')"
            />
          </div>
        </el-col>
      </el-col>
      <el-col :xs="24" :sm="24" :md="8">
        <div class="rectangle">
          <div v-if="!registerConfirmation">
            <span class="connexion">{{ $t("users.registration.title") }}</span>
            <p class="mt-20">
              {{ $t("users.registration.intro") }}
            </p>
            <RegisterComponent
              :cta-submit-text="$t('users.registration.label.register')"
              @show-confirmation="showConfirmation"
            />
          </div>
          <div v-else>
            <div style="height: 30px">
              <img
                class="confirmation-logo"
                :src="images.confirmationSuccess.src"
                alt="confirmation success"
              />
              <h4>{{ $t("users.registration.confirmationSuccess") }}</h4>
            </div>
            <!-- eslint-disable -->
            <p
              style="clear: both"
              class="m-20"
              v-html="$t('users.registration.confirmationText')"
            ></p>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import imgConfirmationSuccess from "@/assets/images/confirmation-success.svg";

import AuthenticateComponent from "./components/authenticate-form.vue";
import RegisterComponent from "./components/register-form.vue";

export default {
  components: {
    AuthenticateComponent,
    RegisterComponent,
  },
  props: {},
  data() {
    return {
      registerConfirmation: false,
      images: {
        confirmationSuccess: {
          src: imgConfirmationSuccess,
        },
      },
    };
  },
  methods: {
    showConfirmation() {
      this.registerConfirmation = true;
    },
  },
};
</script>

<style scoped>
.rectangle {
  min-height: 420px;
  box-sizing: border-box;
  font-family: 'Futura Std', 'Futura Std', sans-serif;
  color: #333333;
  text-align: center;
  line-height: normal;
  padding-top: 40px;
  margin-bottom: 30px;
  text-align: left;
  letter-spacing: 0.5px;
  margin-right: 30px;
  margin-left: 30px;
}
.connexion {
  width: 93px;
  height: 24px;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: bold;
  color: #333333;
  text-align: left;
  line-height: normal;
  letter-spacing: 0.25px;
  margin-bottom: 18px;
  font-size: 18px;
}
.confirmation-logo {
  float: left;
  margin-right: 10px;
}

h4 {
  float: left;
}
</style>
